// @ts-strict-ignore
import styled from "styled-components";

export const FeaturedContributorsListContainer = styled.div`
  padding: 24px;
  margin-left: 32px;
  margin-right: 32px;
  margin-top: 32px;
  border: 1px solid ${({ theme }) => theme.borderColors.primary};
  border-radius: 8px;
  background-color: white;

  ${({ theme }) => theme.media.tablet`
    padding: 32px;
    margin-left: 32px;
    margin-right: 32px;
    margin-top: 32px;
  `}

  ${({ theme }) => theme.media.desktop`
    padding: 32px 24px;
    // Render in reverse order (featured contributors first and then subscribe second)
    order: 1;
    margin-left: 0;
    margin-right: 0;
    margin-top: 0;
  `}
`;

export const AuthorList = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  ${({ theme }) => theme.media.tablet`
  grid-template-columns: 1fr 1fr;
  `}
  ${({ theme }) => theme.media.desktop`
  grid-template-columns: 1fr;
  `}
`;

export const AuthorContainer = styled.div`
  display: flex;
  margin: 17px 0;
`;

export const AuthorImgContainer = styled.div`
  border-radius: 50%;
  margin-right: 16px;
`;

export const AuthorDetails = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
    color: ${({ theme }) => theme.textColors.primary};
  }
`;
